<template>
  <div>
    <div v-if="!isDetail" class="row" style="align-items: normal !important">
      <div style="padding: 30px" class="col-md-3">
        <div style="display: flex; justify-content: space-between">
          <h5 class="font-bold">Growth</h5>
          <svg @click="detail(growth, 'Growth')" class="icon-svg">
            <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
          </svg>
        </div>
        <div v-for="(item, id) in growth" :key="id" class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-light">{{ item.metricname }}</span>
              <div class="d-flex align-items-end gap-1">
                <span class="bg-desc f-12 f-w-500"
                  >{{ item.total_count }} MilesStone</span
                >
                <span v-if="item.delayed !== 0" class="f-12 f-w-500 delayed"
                  >{{ item.delayed }} delayed</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 30px" class="col-md-3">
        <div style="display: flex; justify-content: space-between">
          <h5 class="font-bold">Digital</h5>
          <svg @click="detail(digital, 'Digital')" class="icon-svg">
            <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
          </svg>
        </div>
        <div v-for="(item, id) in digital" :key="id" class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-light">{{ item.metricname }}</span>
              <div class="d-flex align-items-end gap-1">
                <span class="bg-desc f-12 f-w-500"
                  >{{ item.total_count }} Milestones</span
                >
                <span v-if="item.delayed !== 0" class="f-12 f-w-500 delayed"
                  >{{ item.delayed }} delayed</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 30px" class="col-md-3">
        <div style="display: flex; justify-content: space-between">
          <h5 class="font-bold">NZE</h5>
          <svg @click="detail(nze, 'NZE')" class="icon-svg">
            <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
          </svg>
        </div>
        <div v-for="(item, id) in nze" :key="id" class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-light">{{ item.metricname }}</span>
              <div class="d-flex align-items-end gap-1">
                <span class="bg-desc f-12 f-w-500"
                  >{{ item.total_count }} Milestones</span
                >
                <span v-if="item.delayed !== 0" class="f-12 f-w-500 delayed"
                  >{{ item.delayed }} delayed</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 30px" class="col-md-3">
        <div style="display: flex; justify-content: space-between">
          <h5 class="font-bold">Launchpad</h5>
          <svg @click="detail(launchpad, 'Launchpad')" class="icon-svg">
            <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
          </svg>
        </div>
        <div v-for="(item, id) in launchpad" :key="id" class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-light">{{ item.metricname }}</span>
              <div class="d-flex align-items-end gap-1">
                <span class="bg-desc f-12 f-w-500"
                  >{{ item.total_count }} Milestones</span
                >
                <span v-if="item.delayed !== 0" class="f-12 f-w-500 delayed"
                  >{{ item.delayed }} delayed</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row" style="align-items: normal !important">
      <div style="padding: 30px" class="col-md-3">
        <div style="display: flex; justify-content: space-between">
          <h5>{{ titleDetail }}</h5>
          <svg class="icon-svg">
            <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
          </svg>
        </div>
        <div
          @click="detailSub(item)"
          v-for="(item, id) in dataDetail"
          :key="id"
          class="m-b-5 col-sm-12"
        >
          <div
            :class="{ clicked: item.clicked }"
            class="card small-widget mb-sm-0 bg-card-miles"
          >
            <div class="card-body primary">
              <span class="f-light">{{ item.metricname }}</span>
              <div class="d-flex align-items-end gap-1">
                <span class="bg-desc f-12 f-w-500"
                  >{{ item.total_count }} Milesstones</span
                >
                <span v-if="item.delayed !== 0" class="f-12 f-w-500 delayed"
                  >{{ item.delayed }} delayed</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 30px" class="col-md-9">
        <div class="m-b-20 d-flex align-items-center">
          <div
            :class="titleSub !== '' ? 'breadcrumb_link' : ''"
            class="breadcrumb_text mt-1"
            @click="toPath"
          >
            {{ titleHead }}
          </div>
          <div v-if="titleSub !== ''" class="mx-2">
            <img src="@/assets/images/a/arrow.svg" class="breadcrumb_arrow" />
          </div>
          <div
            v-if="titleSub !== ''"
            :class="
              titleSub !== '' ? 'breadcrumb_text mt-1' : 'breadcrumb_link mt-1'
            "
          >
            {{ titleSub }}
          </div>
        </div>
        <div v-if="!isSubDetail" class="row">
          <div class="col-md-8">
            <span style="color: #4e4e4e"
              >Increase revenue from the Electric Vehicle Ecosystem Development
              business, through Home Charging Services Business Stream, SPKLU,
              SPBKLU, and SPLU.</span
            >
            <p style="color: #8b8b8b">Moonshot Leader: EVP PPN</p>
          </div>
          <!-- <div style="text-align: -webkit-right" class="col-md-4">
            <button style="width: 50%" type="button" class="button-download">
              Mooshot Charter <img src="@/assets/images/download_down.svg" />
            </button>
          </div> -->
        </div>
        <hr v-if="!isSubDetail" />
        <!-- <div v-if="!isSubDetail" class="row">
          <div v-for="(item, id) in dataImpact" class="col-md-4">
            <span>{{ item.metricName }}</span
            ><br /><span style="font-weight: bold; font-size: large">{{
              item.value
            }}</span
            ><br />
            <p style="color: #8b8b8b">Aspired annualised impact</p>
          </div>
        </div> -->
        <hr v-if="!isSubDetail" />
        <div class="m-b-10 m-t-10" style="font-size: large; font-weight: bold">
          {{ totalInitiative }} {{ titleInitiative }}
        </div>
        <div v-if="!isSubInitiative">
          <div
            @click="subDetail(item)"
            v-for="(item, id) in dataDetailSub"
            :key="id"
            class="m-b-5 col-sm-12"
          >
            <div class="card small-widget mb-sm-0 bg-card-miles">
              <div
                style="display: flex; justify-content: space-between"
                class="card-body primary"
              >
                <div>
                  <span class="f-16">{{ item.initiative }}</span>
                  <div class="d-flex align-items-end gap-1">
                    <!-- <span class="bg-desc f-12 f-w-500"
                      >{{ item.value }} MilesStone</span
                    > -->
                    <span class="f12 f-light">{{ item.approver }}</span>
                  </div>
                </div>
                <div>
                  <span
                    v-if="item.delayedValue !== null"
                    class="f-12 f-w-500 bg-desc m-r-10"
                    >{{ item.total_count }} Milestones
                  </span>
                  <svg
                    class="icon-svg-detail"
                  >
                    <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            @click="subDetail(item)"
            v-for="(item, id) in dataSubInitiative"
            :key="id"
            class="m-b-5 col-sm-12"
          >
            <div class="card small-widget mb-sm-0 bg-card-miles">
              <div
                class="default-according style-1 faq-accordion bg-card-miles"
                :id="item.isActive"
              >
                <div class="card">
                  <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                      <button
                        class="btn f-16 f-light btn-block text-start"
                        data-bs-target="#collapseicon"
                        :aria-expanded="toogle !== item.subInitiative"
                        aria-controls="collapseicon"
                        v-on:click="expand(item.subInitiative)"
                      >
                        <div class="d-flex justify-content-between">
                          <span>{{ item.subInitiative }}</span
                          ><span class="f-12 f-w-500 bg-desc m-r-10"
                            >{{ item.total_count }} Milestones
                          </span>
                        </div>
                      </button>
                    </h2>
                  </div>
                  <div
                    class="collapse"
                    id="collapseicon"
                    aria-labelledby="collapseicon"
                    data-parent="#accordion"
                    :class="{ show: toogle === item.subInitiative }"
                  >
                    <div class="card-body socialprofile filter-cards-view">
                      <ol>
                        <li v-for="(datas, id) in item.data" :key="id">
                          {{ datas.milestoneName }}
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
                style="display: flex; justify-content: space-between"
                class="card-body primary"
              >
                 <div>
                  <span class="f-16">{{ item.subInitiative }}</span>
                  <div class="d-flex align-items-end gap-1">
                    <span class="f12 f-light">{{ item.approver }}</span>
                  </div>
                </div>
                <div>
                  <span
                    v-if="item.delayedValue !== null"
                    class="f-12 f-w-500 bg-desc m-r-10"
                    >{{ item.value }} MilesStone
                  </span>
                  <svg
                    @click="detail(growth, 'Growth')"
                    class="icon-svg-detail"
                  >
                    <use href="@/assets/svg/icon-sprite.svg#arrow-right"></use>
                  </svg>
                </div> 
              </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import MoonshotService from "@/services/moonshot/moonshot";
const getMoonshot = MoonshotService.build();
export default {
  props: [
    "growth",
    "digital",
    "nze",
    "launchpad",
    "dataMoonshotMilestone",
    "seriesMile",
    "optionsMile",
    "dataImpact",
  ],
  components: {
    // IconSvg,
  },
  data() {
    return {
      toogle: null,
      dataSubInitiative: [],
      isSubInitiative: false,
      isSubDetail: false,
      totalInitiative: "",
      dataDetailSub: [],
      titelSub: "",
      isDetail: false,
      titleDetail: "",
      titleHead: "",
      titleSub: "",
      titleInitiative: "Initiative",
      dataDetail: [],
      dataMiles: [
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "2 delayed",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "2 delayed",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "",
        },
        {
          title: "Internet Fiber Scale Up",
          desc: "47 MilesStone",
          delayed: "",
        },
      ],
      breadcrumb: [],
      isActiveMonth: false,
    };
  },
  mounted() {
    // this.$store.state.moonshot
  },
  methods: {
    expand(x) {
      if (this.toogle === x) {
        this.toogle = null; // Close the accordion if it's already open
      } else {
        this.toogle = x; // Open the clicked accordion item
      }
    },
    toPath() {
      this.titleSub = "";
      this.isSubDetail = false;
      this.isSubInitiative = false;
      this.titleInitiative = "Initiative";
      const datas = this.dataDetailSub;
      this.totalInitiative = datas.length;
    },
    async subDetail(x) {
      if (this.isSubDetail) {
        return;
      } else {
        this.isSubInitiative = true;
        this.isSubDetail = true;
        const param = {
          initiative: x.initiative,
        };
        const res = await getMoonshot.getDataDetailInitiative(param);
        const data = res.data.data.data;
        let newArray = data.map((obj) => ({
          ...obj,
          isActive: false, // Add newKey with value 'someValue' to each object
        }));
        this.titleInitiative = "Sub Initiative";
        this.totalInitiative = data.length;
        this.titleSub = x.initiative;
        this.dataSubInitiative = newArray;
      }
    },
    async detailSub(x) {
      const param = {
        directorate: "consolidated",
        type: x.id,
      };
      const res = await getMoonshot.getDataDetailMM(param);
      const data = res.data.data;
      this.isSubInitiative = false;
      this.breadcrumb.push({ name: x.metricname });
      this.dataDetailSub = data.dataInitiatives;
      this.totalInitiative = data.dataInitiatives.length;

      this.titleHead = x.metricname;
      this.titleSub = "";
      this.isSubDetail = false;
      this.dataDetail.forEach((e) => {
        if (e.id === x.id) {
          e.clicked = true;
        } else {
          e.clicked = false;
        }
      });
      this.titleInitiative = "Initiative";
    },
    detail(x, y) {
      this.$store.commit("updateJudulHalaman", `${y} Moonshot`);
      this.titleDetail = y;
      this.dataDetail = x;
      this.titleSub = "";
      this.isSubInitiative = false;
      this.isSubDetail = false;
      this.detailSub(x[0]);
      this.isDetail = true;
      this.$emit("editTimeline", y);
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
  },
};
</script>
<style scoped>
.icon-svg {
  cursor: pointer;
}
.clicked {
  border: 1px solid #00a3e9;
  background-color: #ecf9ff;
}
</style>
